export function axiosErrorMessage(e: unknown, fallback: string): string {
  if (typeof e === 'object' && e !== null) {
    const data = (e as { response?: { data?: { message?: unknown } } }).response?.data?.message;

    if (typeof data === 'string') return data;
  }
  if (e instanceof Error) return e.message;

  return fallback;
}
